var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var DashboardController = /** @class */ (function () {
    function DashboardController() {
    }
    /*****************************************************************************************************
        * Is using route "api/dashboard" and http method "POST" to call the back-end.
    
        * @param {string[]} types
        * @returns {DashboardDownloadDto[]}
    ******************************************************************************************************/
    DashboardController.GetDashboards = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.types
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/create" and http method "POST" to call the back-end.
    
        * @param {DashboardUploadDto} dashboard
        * @returns {DashboardDownloadDto}
    ******************************************************************************************************/
    DashboardController.AddDashboard = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/create", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {DashboardUploadDto} dashboard
        * @returns {DashboardDownloadDto}
    ******************************************************************************************************/
    DashboardController.UpdateDashboard = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DashboardController.DeleteDashboard = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/elements" and http method "GET" to call the back-end.
    
        * @returns {DashboardElementTemplateDownloadDto[]}
    ******************************************************************************************************/
    DashboardController.GetDashboardElements = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/elements", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/forgrouptype/elements" and http method "POST" to call the back-end.
    
        * @param {DashboardElementTemplateFilter} filter
        * @returns {DashboardElementTemplateDownloadDto[]}
    ******************************************************************************************************/
    DashboardController.GetDashboardElementTemplates = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/forgrouptype/elements", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/template" and http method "GET" to call the back-end.
    
        * @returns {DashboardTemplateDownloadDto[]}
    ******************************************************************************************************/
    DashboardController.GetDashboardTemplates = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/template" and http method "POST" to call the back-end.
    
        * @param {DashboardTemplateUploadDto} dashboard
        * @returns {DashboardTemplateDownloadDto}
    ******************************************************************************************************/
    DashboardController.AddDashboardTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/template/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {DashboardTemplateUploadDto} dashboard
        * @returns {DashboardDownloadDto}
    ******************************************************************************************************/
    DashboardController.UpdateDashboardTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    };
    /*****************************************************************************************************
        * Is using route "api/dashboard/template/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DashboardController.DeleteDashboardTemplate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return DashboardController;
}());
export { DashboardController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=DashboardController.js.map